import ReactMarkdown from 'react-markdown';
import styles from './Markdown.module.scss';

export const Markdown = ({ markdown }: { markdown: string }) => {
  // NOTE: due to backend limitations, we need to replace \n with 2 spaces and a newline
  const tooltip = `${markdown.replace(/\\n/g, '  \n')}`;
  return <ReactMarkdown className={styles.wrapper}>{tooltip}</ReactMarkdown>;
};
